export const AUCTIONS_CATALOG_ID = window.$('script[data-auctions-catalog-id]').data('auctions-catalog-id');
export const MODAL_OPEN_CLASS = 'modal-open';
export const DETAILS_TYPE = 'OrdersDetails';



// WEBPACK FOOTER //
// ./app/javascript/packs/employees_orders_panel/consts.js